import { render } from "./OffboardingExportPanel.vue?vue&type=template&id=5ed62d32"
import script from "./OffboardingExportPanel.vue?vue&type=script&lang=js"
export * from "./OffboardingExportPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__